const getHomeLink = () => {
  return '/'
}

export { getHomeLink }
